import RevisableLanguagePack from "../../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import MediatorManager from "../../../../core/application/MediatorManager";
import OpenChatEvent from "../../../chat/events/OpenChatEvent";
import SmartphoneNavigateEvent from "../../model/SmartphoneNavigateEvent";
import SmartphoneSkinKeyRegistry from "../../model/SmartphoneSkinKeyRegistry";
import AbstractSmartphoneMediator from "../AbstractSmartphoneMediator";

export default class SmartphoneChatContactsScreenMediator extends AbstractSmartphoneMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {MediatorManager} mediatorManager 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, mediatorManager, languagePack) {
        super(target, dispatcher);

        this._mediatorManager = mediatorManager;
        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();

        this._target.applicationTitleTextField.text = this._languagePack.getText(`chat.applicationTitle`);
        this._closeButton = this.createButton(this._target.closeButton, this._handleCloseButton.bind(this));

        this._target.customData = {
            skinKeyRegistry: SmartphoneSkinKeyRegistry
        };
        this._chatContactsMediator = this._mediatorManager.createMediator(this._target, SmartphoneSkinKeyRegistry.CHAT_CONTACTS_SCREEN_SKIN);

        this.registerEventListener(OpenChatEvent.PERFORM, this._handleOpenChat.bind(this));
    }

    destroy() {
        super.destroy();

        this._chatContactsMediator.destroy();
    }

    _handleCloseButton() {
        // const navEvt = new SmartphoneNavigateEvent(SmartphoneNavigateEvent.CLOSE_ALL_SCREENS_REQUEST);
        // this.dispatch(navEvt.type, { data: navEvt });

        // this.gotoScreen(SmartphoneSkinKeyRegistry.SMARTPHONE_MAIN_SCREEN_SKIN);

        this.dispatch(SmartphoneNavigateEvent.SMARTPHONE_HIDE_REQUEST);
    }

    _handleOpenChat(evt) {
        const data = evt.params.data;
        this.openScreen(SmartphoneSkinKeyRegistry.SMARTPHONE_CHAT_SCREEN_SKIN, null, {
            npcId: data.npcId,
        });
    }
}